import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const isRTL = i18n.language === 'ar';
  const isHomePage = location.pathname === '/';

  if (!isOpen) return null;

  const handleSectionClick = (sectionId: string) => {
    onClose();
    if (isHomePage) {
      setTimeout(() => {
        const el = document.getElementById(sectionId);
        if (el) {
          const headerHeight = 72;
          const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 100);
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  return (
    <div className="fixed inset-0 z-40 md:hidden">
      <div className="absolute inset-0 bg-black/40" onClick={onClose}></div>
      <div className={`absolute ${isRTL ? 'left-0' : 'right-0'} top-0 w-64 h-full bg-background-50 shadow-lg p-6`}>
        <button onClick={onClose} className="mb-8 text-foreground-700 font-medium cursor-pointer">
          {t('mobile.close')}
        </button>
        <nav className="flex flex-col space-y-4">
          <Link to="/" className="text-foreground-900 hover:text-primary-600 transition-colors text-base" onClick={onClose}>
            {t('nav.home')}
          </Link>
          <a
            href="/#services"
            onClick={(e) => { e.preventDefault(); handleSectionClick('services'); }}
            className="text-foreground-900 hover:text-primary-600 transition-colors text-base cursor-pointer"
          >
            {t('nav.services')}
          </a>
          <a
            href="/#register"
            onClick={(e) => { e.preventDefault(); handleSectionClick('register'); }}
            className="text-foreground-900 hover:text-primary-600 transition-colors text-base cursor-pointer"
          >
            {t('nav.register')}
          </a>
          <Link to="/blog" className="text-foreground-900 hover:text-primary-600 transition-colors text-base" onClick={onClose}>
            {t('nav.blog')}
          </Link>
          <Link to="/help-center" className="text-foreground-900 hover:text-primary-600 transition-colors text-base" onClick={onClose}>
            {t('footer.helpCenter')}
          </Link>
        </nav>
      </div>
    </div>
  );
}